<template>
  <q-select
    v-model="selectedPeriod"
    :options="periods"
    :loading="!financialPeriods"
    :options-dark="false"
    :dark="dark"
    hide-bottom-space
    class="year-dropdown"
    dense
    v-bind="nonDarkOptions"
    outlined
    label="Year"
    emit-value
    map-options
  />
</template>

<script>
// Libraries
import { mapState } from 'vuex'

export default {
  props: {
    value: { required: true },
    dark: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState('financial-insights', ['financialPeriods']),

    nonDarkOptions() {
      if (this.dark)
        return {
          'bg-color': 'transparent',
          'label-color': 'white'
        }
      return {}
    },

    periods() {
      if (!this.financialPeriods) return []

      return this.financialPeriods.map(period => ({ label: period.abbreviation, value: period.id }))
    },

    selectedPeriod: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  watch: {
    financialPeriods: {
      handler: 'setDefaultSelectedPeriod',
      immediate: true
    }
  },

  methods: {
    setDefaultSelectedPeriod(periods) {
      if (!periods || !!this.value) return // if `value` (selectedPeriod) is NOT null or if `periods` is null don't do anything

      const period = periods.find(p => !!p.is_current)
      this.selectedPeriod = period.id
    }
  }
}
</script>

<style lang="stylus" scoped>
.year-dropdown {
  width 120px
  height 40px
}
</style>
